export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "mapbox-gl-csp-worker-18b2d9f68bb07091abd3.worker.js");
}
